import { render } from "./WCEditSpecialOrderItemModal.vue?vue&type=template&id=0d54ab47&scoped=true"
import script from "./WCEditSpecialOrderItemModal.vue?vue&type=script&lang=js"
export * from "./WCEditSpecialOrderItemModal.vue?vue&type=script&lang=js"

import "./WCEditSpecialOrderItemModal.vue?vue&type=style&index=0&id=0d54ab47&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d54ab47"]])

export default __exports__